/** Settings → Account: the account rows and the password, invoices and delete pages. */
export default {
  enterName: "Enter a name.",
  loadFailedTitle: "Couldn’t load your account.",
  loadFailedLine: "Check your connection and try again.",
  linkRecentlySent: "A link was sent a few minutes ago. Check your inbox.",
  sendLinkFailed: "Couldn’t send the link. Try again.",
  saveFailed: "Couldn’t save your change. Try again.",
  planLoadFailed: "Couldn’t load your plan",
  name: "Name",
  notVerified: "Not verified",
  linkSent: "Link sent",
  sendingLink: "Sending…",
  sendLink: "Send link",
  changePassword: "Change password",
  timeZone: "Time zone",
  billingLoadFailed: "Couldn’t load billing details",
  cardEnding: "{brand} ending in {last4}",
  cardExpires: "Expires {month}/{year}",
  invoices: "Invoices",
  signOut: "Sign out",
  deleteAccount: "Delete account",
  passwordsDontMatch: "Passwords don’t match.",
  changePasswordFailed: "Failed to change password",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmNewPassword: "Confirm new password",
  changingPassword: "Changing…",
  invoicesLoadFailed: "Couldn’t load invoices.",
  noInvoices: "No invoices yet.",
  invoiceSummary: "{amount}, {status}",
  invoiceStatusDraft: "draft",
  invoiceStatusOpen: "open",
  invoiceStatusPaid: "paid",
  invoiceStatusUncollectible: "uncollectible",
  invoiceStatusVoid: "void",
  deleteFailed: "Failed to delete account",
  deleteTitle: "Delete your account?",
  deleteLine:
    "This permanently deletes your projects, chats and memory. It can’t be undone.",
  deletePhrase: "delete my account",
  deleteConfirmLabel: "Type “{phrase}” to confirm",
  deleting: "Deleting…",
  deletePermanently: "Delete permanently",
} as const;
